// const baseUrl = 'http://10.0.0.23:8081'
// const baseUrl = 'http://localhost:8081'
// const baseUrl = 'http://192.168.110.19:8081'
// const baseUrl = 'http://47.97.195.120:9001'
// const baseUrl = 'http://47.94.227.40:9001'  //测试环境
const baseUrl = 'https://wmzh.life-oasis.com/api';
// const baseUrl = 'https://yxzh.life-oasis.com/apis';
export default baseUrl;